// totalStep="1" (질문 1개)- 1.이름&번호
// totalStep="2" (질문 2개)- 1.임플란트 갯수, 2.이름&번호
// numberColor - #0854fc(밝은 파란색),#0824a4(남색), #3f8c58(짙은 녹색),#18646c(청록색)
// qOptionColor - blue, green, teal

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import { validateName, validatePhoneNumber } from "../utils/validation";
import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import SelectEvents from "../components/SelectEvents";
import ButtonGroup from "../components/ButtonGroup";
import PrivacyContent from "./PrivacyContent";

function RandingStyle14({
  urlCode,
  urlCodeSettingId,
noevent,
  img1Path,
  img2Path,
  img3Path,
  question1,
  question2,
  question3,
  btnOption1,
  btnOption2,
  btnOption3,
  btnOption4,
  btnOption5,
  btnOption6,
  btnOption7,
  btnOption8,
  propsImplantValues,
  buttonGroupVer,
  postBTN,
  companyName,
  articleOption,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();

  // 상태 관리.
  const [selectedValue, setSelectedValue] = useState(null); // 선택된 값을 저장할 상태

  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const nextStep = () => {
    if (currentStep < 2) setCurrentStep(currentStep + 1);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      craftTag: true,
      kakaotalk,
      carrotTag,
    });
  };

  // 크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트
  const [buttonGroup1, setButtonGroup1] = useState({
    btn1: btnOption1,
    btn2: btnOption2,
    btn3: btnOption3,
  });

  const [buttonGroup2, setButtonGroup2] = useState({
    btn4: btnOption4,
    btn5: btnOption5,
    btn6: btnOption6,
  });

  const [buttonGroup3, setButtonGroup3] = useState({
    btn1: btnOption1,
    btn2: btnOption2,
    btn3: btnOption3,
    btn4: btnOption4,
  });

  const [buttonGroup4, setButtonGroup4] = useState({
    btn5: btnOption5,
    btn6: btnOption6,
    btn7: btnOption7,
    btn8: btnOption8,
  });
  const [group1Selected, setGroup1Selected] = useState(null);
  const [group2Selected, setGroup2Selected] = useState(null);
  const [group3Selected, setGroup3Selected] = useState(null);
  const [group4Selected, setGroup4Selected] = useState(null);

  const handleSelectImplant = (group, key) => {
    const implantValues = {
      btn1: "1~2개",
      btn2: "3~4개",
      btn3: "5개 이상",
      btn4: "비용부담",
      btn5: "치과공포증",
      btn6: "의료진",
    };

    const selectedValue = key
      ? buttonGroupVer
        ? propsImplantValues[key]
        : implantValues[key] // buttonGroupVer이 있으면 propsImplantValues, 없으면 implantValues 사용
      : null;

    console.log("선택된 값:", selectedValue);

    if (group === 1) {
      setGroup1Selected(selectedValue);
    } else if (group === 2) {
      setGroup2Selected(selectedValue);
    } else if (group === 3) {
      setGroup3Selected(selectedValue);
    } else if (group === 4) {
      setGroup4Selected(selectedValue);
    }

    // 상태 업데이트 이후 최신 값 기반으로 조합
    setSelectedOption((prev) => {
      const group1Value = group === 1 ? selectedValue : group1Selected;
      const group2Value = group === 2 ? selectedValue : group2Selected;
      const group3Value = group === 3 ? selectedValue : group3Selected;
      const group4Value = group === 4 ? selectedValue : group4Selected;

      // group3, group4를 사용할지 group1, group2를 사용할지 결정
      const value1 = buttonGroupVer ? group3Value : group1Value;
      const value2 = buttonGroupVer ? group4Value : group2Value;

      return `${value1 || ""}${value1 && value2 ? ", " : ""}${value2 || ""}`;
    });
  };

  // 크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트크래프트

  return (
    <div className="form-container">
      <div className="step2">
        <div className="rel">
          {articleOption && (
            <p className="notice-limited-event">
              ※{new Date().getMonth() + 1}월 한정 이벤트 입니다※
              <br />
              ※위 이벤트는 조기종료될 수 있습니다※
            </p>
          )}
          {img1Path && <img src={img1Path} />}
          {img2Path && <img src={img2Path} />}
          {img3Path && <img src={img3Path} />}
        </div>

        <div className="qBox">
          <div className="qTitleSmall">
            {question1 ? (
              <img src={question1} alt="Question 1" /> // 이미지가 있을 때 보여주는 부분
            ) : (
              <>
                <span>Q1.</span>
                <p>임플란트 필요한 개수는?</p>
              </>
            )}
          </div>
          <ButtonGroup
            buttonOptions={buttonGroupVer ? buttonGroup3 : buttonGroup1}
            onButtonClick={(updatedOptions) =>
              buttonGroupVer
                ? setButtonGroup3(updatedOptions)
                : setButtonGroup1(updatedOptions)
            }
            onSelect={(key) => handleSelectImplant(buttonGroupVer ? 3 : 1, key)} // 그룹 1 선택 처리
            buttonGroupVer={buttonGroupVer}
          />
          <div className="qTitleSmall">
            {question2 ? (
              <img src={question2} alt="Question 2" /> // 이미지가 있을 때 보여주는 부분
            ) : (
              <>
                <span>Q2.</span>
                <p>임플란트 시술 망설인 이유는?</p>
              </>
            )}
            {/* 버튼 그룹 2 */}
          </div>
          <ButtonGroup
            buttonOptions={buttonGroupVer ? buttonGroup4 : buttonGroup2}
            onButtonClick={(updatedOptions) =>
              buttonGroupVer
                ? setButtonGroup4(updatedOptions)
                : setButtonGroup2(updatedOptions)
            }
            onSelect={(key) => handleSelectImplant(buttonGroupVer ? 4 : 2, key)} // 그룹 2 선택 처리
            buttonGroupVer={buttonGroupVer}
          />
          {
            <div className="qTitleSmall" style={{ marginBottom: "20px" }}>
              {question3 ? (
                <img src={question3} alt="Question 3" /> // 이미지가 있을 때 보여주는 부분
              ) : (
                <>
                  <span>Q3.</span>
                  <p>혜택 적용을 받으실 분의 성함과 연락처를 입력해주세요</p>
                </>
              )}
            </div>
          }
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          <form
            className="formBox"
            onSubmit={(e) => {
              e.preventDefault(); // 기본 제출 동작 방지
              handleSubmit(); // 기존 handleSubmit 호출
            }}
          >
            <div className="formField">
              <label htmlFor="name">이름</label>
              <input
                type="text"
                id="name"
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required // 필수 입력 필드
              />
            </div>

            <PhoneNumberInput
              phoneNumber={phoneNumber}
              phoneFirstOptions={phoneFirstOptions}
              handlePhoneNumberChange={handlePhoneNumberChange}
            />
            {!noevent && (
              <p className="benefitInfo">
                <BenefitPeriod />
                <br />
                이벤트 대상자 : 해당 매체 이용자
              </p>
            )}
            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
            />

            {isPrivacyPolicyModal && (
              <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
                <div
                  className="privacyPolicyContent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <PrivacyContent companyName={companyName} />
                </div>
              </div>
            )}
            <button
              type="submit"
              className="sendBtnBox"
              disabled={isSubmitting}
            >
              <img src={postBTN} alt="신청하기" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RandingStyle14;
